import {
  Component,
  Injector,
  OnInit,
  EventEmitter,
  Output,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { forEach as _forEach, map as _map } from 'lodash-es';
import { AppComponentBase } from '@shared/app-component-base';
import {
  ConsultaDto,
  ConsultaServiceProxy,
  SolicitarExameDto
} from '@shared/service-proxies/service-proxies';

@Component({
  templateUrl: './solicitar-exame-dialog.component.html',
  styleUrls: ['./solicitar-exame-dialog.component.scss'],
})
export class SolicitarExameDialogComponent extends AppComponentBase {
  saving = false;
  solicitacao: SolicitarExameDto = new SolicitarExameDto();
  consulta: ConsultaDto;
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();

  constructor(
    injector: Injector,
    private readonly bsModalRef: BsModalRef,
    private readonly _consultaService: ConsultaServiceProxy

  ) {
    super(injector);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onCancel.emit();
  }

  get disableSave(): boolean {
    return this.saving || this.solicitacao.nome == null || this.solicitacao.nome == "";
  }

  save(): void {
    if (!this.solicitacao.nome || this.solicitacao.nome == "") {
      return;
    }

    this.solicitacao.consultaId = this.consulta.id;

    this.saving = true;
    abp.ui.setBusy();
    this._consultaService
      .solicitarExame(this.solicitacao)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((x) => {
        this.notify.success("Exame solicitado com sucesso");
        this.bsModalRef.hide();
        this.onSave.emit();
      });

  }
}



